import React from 'react'
import { Modal } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'

const ModalMensagge = ({ show, handleClose, message, onSubmitModal }) => {
  return (
    <Modal
      className='d-flex  align-items-center justify-content-center square border border-4 '
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Notificaciones</Modal.Title>
      </Modal.Header>
      <Modal.Body className='square border border-4 m-2'>{message}</Modal.Body>
      <Modal.Footer>
        <Button type='button' onClick={onSubmitModal} variant='primary'>
          Aceptar
        </Button>
        <Button variant='secondary' onClick={handleClose}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalMensagge
